import React from "react";
import { NonTimerCard } from "./styles";
import { UserIcon } from "../../../../../../components/IconsSVG";
import { WhatsAppButton } from "../Button/style";
import Swal from "sweetalert2";

export const NonTimersProfessionalCard = ({ professional }) => {
  return (
    <NonTimerCard>
      {UserIcon("#fff")}
      <span>{`${professional.name} - Sem lançamentos`}</span>
      <WhatsAppButton
        type="button"
        title="Abrir WhatsApp"
        onClick={e => {
          e.stopPropagation();
          const phone = professional.phone?.replace(/\D/g, "");

          if (!phone) {
            Swal.fire(
              "Telefone não encontrado",
              "Este usuário não possui um telefone cadastrado.",
              "warning"
            );
            return;
          }

          window.open(
            `https://wa.me/55${phone}`,
            "_blank",
            "noopener,noreferrer"
          );
        }}
      >
        <i className="fab fa-whatsapp" />
      </WhatsAppButton>
    </NonTimerCard>
  );
};
